















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component
export default class Pagination extends Vue {

  public currentPage: number = 1;
  public totalItem: any[] = [];

  @Prop({ default: [] }) public data!: any[];
  @Prop({ default: '' }) public layout!: string;
  @Prop({ default: () => [10, 15, 20] }) public itemSizes!: number[];
  @Prop({ default: 10 }) public itemSizeSelected!: number;

  @Watch('data') public onDataChanges() {
    this.setItemPerPages([...this.data], this.itemSizeSelected);
  }
  @Watch('itemSizeSelected') public onSizeSelectedChanges() {
    this.setItemPerPages([...this.data], this.itemSizeSelected);
    if (this.currentPage > 1) {
      this.currentPage = 1;
      this.setShowItem();
    }
  }


  // constructor() {
  //   super();
  // }

  get totalSize() {
    return this.data.length;
  }

  get getItemSizes() {
    return this.itemSizes.map((e: any) => e.value);
  }

  get getItemSizeSelected() {
    return this.itemSizeSelected;
  }

  public handleSizeChange(event: number) {
    
    this.setItemPerPages([...this.data], event);
  }
  public handleCurrentChange(event: number) {
    this.$emit('current-page-change', event);
    this.setShowItem();
  }

  public setItemPerPages(data: any[], item: number = 10) {
    const val = [];
    const arr = data;
    while (arr.length > 0) {
      val.push(arr.splice(0, item));
    }
    this.$set(this, 'totalItem', val);
    this.setShowItem();
  }

  public setShowItem() {
    const item = this.totalItem[this.currentPage - 1] || [];
    this.$emit('input', item);
  }

  //   private mounted() {
  //     this.setItemPerPages([...this.data]);
  //   }

}
